import React, { useState } from "react";
import { Form, Input, Select, Button, message, Spin } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useLanguage } from "../../context/LanguageContext";
import { useDoctorQuery } from "../../hooks/useDoctorQuery";
import drEasyApi from "../../Api/Customapi";
import { Loader, LoaderCircle } from "lucide-react";
import { BiLoaderCircle } from "react-icons/bi";
import { motion } from 'framer-motion';

export function ContactForm() {
  const [form] = Form.useForm();
  const { t } = useLanguage();
  const { data: center } = useDoctorQuery()
  const [loading, setIsLoading] = useState(false)
  async function handleSubmit(values) {

    try {
      setIsLoading(true)
      const payload = {
        name: values.name,
        email: values.email,
        phone: values.phone,
        message: values.message,
        subject: values.subject,
        centerId: center?.id
      }
      const res = await drEasyApi.post('/api/Contact/SendContact', payload)
      form.resetFields();
      message.success("success send contact")

    } catch {
      message.error("faild send contact")
    } finally {
      setIsLoading(false)
    }
  }
  const fadeInUp = {
        hidden: { opacity: 0, y: 30 },
        visible: (i = 1) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.3,
                duration: 0.6,
                ease: 'easeOut',
            },
        }),
    };

  return (
    <motion.div
        initial="hidden"
                    animate="visible"
                    variants={fadeInUp}
                    custom={0}
     className="w-full">
      <div className=" bg-cardColor p-6 rounded-2xl shadow-lg">
        <Form
          form={form}
          layout="vertical"
  className="space-y-7 [&_.ant-form-item-label_label]:text-gold [&_.ant-form-item-label_label]:font-semibold"
          onFinish={handleSubmit}
        >

          {/* Full Name */}
          <Form.Item
            label={t("contact.fullName")}
            name="name" 
            
            rules={[{ required: true, message: t("common.required") }]}
          >
            <Input size="large" placeholder={t("contact.fullNamePlaceholder")} />
          </Form.Item>

          {/* Phone */}
          <Form.Item
            label={t("contact.phoneN")}
            name="phone"
          >
            <Input size="large" placeholder={t("contact.phonePlaceholder")} />
          </Form.Item>

          {/* Email */}
          <Form.Item
            label={t("contact.emailA")}
            name="email"
            rules={[
              { required: true, message: t("common.required")},
              { type: "email", message: t("auth.emailInvalid")}
           
            ]}
          >
            <Input size="large" placeholder={t("contact.emailPlaceholder")} />
          </Form.Item>

          <Form.Item
            label={t("contact.serviceNeeded")}
            name="subject"
               rules={[
              { required: true, message: t("common.required") },
            ]}
          >
            <Input size="large" placeholder={t("contact.serviceNeededPlaceholder")} />


          </Form.Item>

          {/* Message */}
          <Form.Item
            label={t("contact.message")}
            name="message"
               rules={[
              { required: true, message: t("common.required") },
            ]}
          >
            <TextArea
              placeholder={t("contact.messagePlaceholder")}
              rows={4}
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <div className="flex justify-end">
              <Button
                type=""
                htmlType="submit"
                className="bg-gold hover:bg-goldy text-white"
              >
                {loading ? <LoaderCircle className="animate-spin" /> : t("contact.submit")}
              </Button>
            </div>
          </Form.Item>

        </Form>
      </div>
    </motion.div>
  );
}
